import { get } from "lodash";
// @ts-ignore
import { Location } from "react-router-dom";
import mediator from "@tvg/mediator";
import tvgConf from "@tvg/conf";

type PageViewGtmEvent = {
  location: Location;
  accountNumber: string;
  isLogged: boolean;
  balance: number | string;
  homeState: string;
  privateBrowser: string | null;
  raceNumber: string | number | null;
  trackName: string;
  raceStatus: string | number | undefined;
  mtp: string;
  fdtvType?: string;
};

export const pageViewGtmEvent = ({
  location,
  accountNumber,
  isLogged,
  balance,
  homeState,
  privateBrowser,
  raceNumber,
  trackName,
  raceStatus,
  mtp,
  fdtvType = "non_fdtv"
}: PageViewGtmEvent) => {
  mediator.base.dispatch({
    type: "LOAD:RACE_PAGE_VIEW",
    payload: {
      accountId: accountNumber || undefined,
      balance: isLogged ? balance : undefined,
      event: "ga_pageload",
      loginStatus: isLogged ? "Logged In" : "Logged Out",
      page:
        get(location, "pathname") +
        get(location, "search", "") +
        get(location, "hash", ""),
      privateBrowser,
      productVersion: "TVG5",
      residenceState: homeState || undefined,
      screenName: "Program Page",
      sectionName: "Program Page",
      siteVersion: tvgConf().gaConfig().siteVersion,
      sport: "Horse Racing",
      raceNumber,
      trackName,
      raceStatus,
      mtp,
      fdtvType
    }
  });
};
